import React from "react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import WhatsAppFloat from "@/components/WhatsAppFloat";
import BookingDialog from "@/components/BookingDialog";
import Hero from "@/components/sections/Hero";
import About from "@/components/sections/About";
import Services from "@/components/sections/Services";
import Doctors from "@/components/sections/Doctors";
import Facilities from "@/components/sections/Facilities";
import SmileTransformations from "@/components/sections/SmileTransformations";
import Gallery from "@/components/sections/Gallery";
import Testimonials from "@/components/sections/Testimonials";
import FAQ from "@/components/sections/FAQ";
import Contact from "@/components/sections/Contact";

export default function Home() {
    const [bookOpen, setBookOpen] = React.useState(false);
    const [initialService, setInitialService] = React.useState(null);

    const openBooking = (service) => {
        if (typeof service === "string") setInitialService(service);
        else setInitialService(null);
        setBookOpen(true);
    };

    return (
        <div className="bg-[#faf9f6] text-[#1a1d1c] font-sans-body">
            <Navbar onBook={() => openBooking()} />
            <main>
                <Hero onBook={() => openBooking()} />
                <About />
                <Services onBook={openBooking} />
                <Doctors onBook={() => openBooking()} />
                <Facilities />
                <SmileTransformations onBook={() => openBooking()} />
                <Gallery />
                <Testimonials />
                <FAQ />
                <Contact />
            </main>
            <Footer />
            <WhatsAppFloat />
            <BookingDialog
                open={bookOpen}
                onOpenChange={setBookOpen}
                initialService={initialService}
            />
        </div>
    );
}
